import { Box, Stack, Typography, Chip } from '@mui/material';

/**
 * Standard page heading: title, optional count, subtitle, and right-aligned actions.
 * Generalised from the pattern hand-written in Patient.jsx so every page announces
 * itself the same way.
 */
const PageHeader = ({ title, subtitle, count, actions, sx }) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    alignItems={{ xs: 'stretch', sm: 'center' }}
    justifyContent="space-between"
    spacing={2}
    sx={{ mb: 2.5, ...sx }}
  >
    <Box>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h2">{title}</Typography>
        {count !== undefined && count !== null && (
          <Chip size="small" label={count} sx={{ bgcolor: 'grey.100', color: 'text.secondary' }} />
        )}
      </Stack>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>

    {actions && (
      <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
        {actions}
      </Stack>
    )}
  </Stack>
);

export default PageHeader;
